import { useFilterTransportTypeContext } from "./filter-transport-type.context";

export function FilterTransportType() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterTransportTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}